import { render, staticRenderFns } from "./getTicketLogs.vue?vue&type=template&id=230f6a44&scoped=true"
import script from "./getTicketLogs.vue?vue&type=script&lang=js"
export * from "./getTicketLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230f6a44",
  null
  
)

export default component.exports